<template>
  <div class="block-navigation-cards">
    <BlockCardCta
      v-for="(card, index) of cards"
      :key="`nav-card-${card.link}-${index}`"
      v-bind="card"
    />
  </div>
</template>

<script setup>
defineProps({
    cards: {
        type: Array,
        default: () => [],
    },
});
</script>

<style lang="scss" scoped>
.block-navigation-cards {
    @include wrapper-layout();
    @include grid-layout(1, 2, 3);

    margin-bottom: var(--m-bottom--medium);
}
</style>
